type ExternalThemeLinkProps = {
  className?: string;
  children: React.ReactNode;
} & React.AnchorHTMLAttributes<HTMLAnchorElement>;

export default function ExternalThemeLink({
  children,
  className,
  ...props
}: ExternalThemeLinkProps) {
  return (
    <a
      {...props}
      className={`font-bold text-blue hover:text-primary cursor-pointer ${
        className ? className : ''
      }`}
    >
      {children}
    </a>
  );
}
